import { useState } from "react";
import { FaAsterisk } from "react-icons/fa";
import { IoMdClose } from "react-icons/io";
import { Select } from "../../SharedModule/components/Select";
import { VscQuestion } from "react-icons/vsc";
import { useSpotlights } from "../hooks/useSpotlights";
import { SpotlightService } from "../services/spotlight";
import { useDispatch } from "react-redux";
import { addToast } from "../../SharedModule/redux/reducers/ui.reducer";
import { useParams } from "react-router";
import {
  setIsLoadingDataSpotlight,
  setNeedRefreshSpotlight,
} from "../redux/reducers/spotlight.reducer";
import eventHandler from "../../SharedModule/utils/eventHandler";
import Editor, { EditorProvider } from "react-simple-wysiwyg";
import { ExternalLink } from "../../SharedModule/components/ExternalLink";

export const ModalPublish = ({
  title,
  btnLabel,
  btnCancelLabel,
  btnCancel,
  lastSpotlight,
  owner,
}: any) => {
  let { productId } = useParams();

  const { spotlightStatuses } = useSpotlights(Number(productId));

  const placeholder =
    "If there are no updates, please give a small explanation as to what happened this week.";

  const dispatch = useDispatch();

  let spotlightStatusesOptions = spotlightStatuses.map((elem: any) => {
    return { value: elem.id.toString(), label: elem.name };
  });

  const [isPublishDisabled, setIsPublishDisabled] = useState(true);

  // set modal with values of last spotlight
  const [state, setState] = useState({
    status: lastSpotlight
      ? { value: lastSpotlight.status.id, label: lastSpotlight.status.name }
      : spotlightStatusesOptions[0],
    comments: lastSpotlight ? lastSpotlight.comment : "",
  });

  const handleChange = (value: any) => {
    setState({ ...state, comments: value });
  };

  const handleSubmit = async () => {
    dispatch(setIsLoadingDataSpotlight(true));
    btnCancel(true);
    let result = await SpotlightService.addSpotlight(
      owner,
      Number(productId),
      Number(state.status.value),
      state.comments
    );
    if (result === "Spotlight added successfully.") {
      dispatch(setNeedRefreshSpotlight(true));
      dispatch(addToast({ mode: "success", message: result }));
    } else {
      dispatch(addToast({ mode: "error", message: "Something went wrong" }));
      dispatch(setIsLoadingDataSpotlight(false));
    }
    eventHandler.dispatch("toast action", { isClosed: false });
  };

  const [maxChars, setMaxChars] = useState(
    10000 - state.comments.replace(/<[^>]*>/g, "").length
  );

  const checkCharacterCount = (event: any) => {
    handleChange(event.target.value);
    let totalChars = event.target.value.replace(/<[^>]*>/g, "").length;

    setMaxChars(10000 - totalChars);
    if (totalChars === 0 || totalChars > 10000) {
      setIsPublishDisabled(true);
    } else {
      setIsPublishDisabled(false);
    }
    if (totalChars > 10000 && event.key !== "Backspace") {
      setIsPublishDisabled(true);
      event.preventDefault();
    }
  };

  return (
    <div className="block" style={{ width: "100%" }}>
      <div className="block-header">
        <h6 style={{ fontWeight: "bold" }}>{title}</h6>
        <div className="d-flex justify-content-between">
          <div
            style={{ width: "85%", fontSize: "11px" }}
            className="grayMedium mt-2"
          >
            Set the current status of your product, and then enter a comment
            about how things have been going the past week.
            <br />
            If there are no changes, enter a small note as to why.
          </div>
          <IoMdClose
            size={"20px"}
            className="pointer grayMedium"
            onClick={() => btnCancel(false)}
            style={{ marginTop: "-25px" }}
          />
        </div>
      </div>
      <div className="block-body">
        <div className="d-flex mt-2 flex-column mb-2">
          <label className="form-label gray-label mb-1">
            STATUS{" "}
            <span className="required">
              <FaAsterisk size={"6px"} />
            </span>
          </label>
          <div className="position-relative d-flex">
            <div style={{ width: "40%" }}>
              <Select
                placeholder="Select Name"
                className="mb-2"
                options={spotlightStatusesOptions}
                isLoading={!spotlightStatusesOptions}
                value={{
                  value: state.status.value,
                  label: state.status.label,
                }}
                onChange={(name: any) => {
                  setState({ ...state, status: name });
                }}
              />
            </div>
            <ExternalLink
              className="ms-3 mt-1 gray-label"
              to="https://itxnet.sharepoint.com/sites/Delivery/SitePages/Spotlight-Reporting.aspx"
            >
              <VscQuestion size={"25px"} />
            </ExternalLink>
          </div>
        </div>
        <div className="d-flex mt-2 flex-column mb-2">
          <label className="form-label gray-label mb-1">
            COMMENTS{" "}
            <span className="required">
              <FaAsterisk size={"6px"} />
            </span>
          </label>
          <EditorProvider>
            <Editor
              value={state.comments}
              onChange={checkCharacterCount}
              placeholder={placeholder}
            />
          </EditorProvider>
          <div className="gray-label mt-2 align-self-end">
            {`Characters left: ${maxChars}`}
          </div>
        </div>
      </div>
      <div className="block-footer">
        <div className="d-flex mt-2">
          <button
            className="btn button-secondary w-100"
            onClick={() => btnCancel(false)}
          >
            {btnCancelLabel}
          </button>
          <button
            className="btn btn-primary w-100 ms-2"
            disabled={isPublishDisabled}
            onClick={() => handleSubmit()}
          >
            {btnLabel}
          </button>
        </div>
      </div>
    </div>
  );
};
